import { render, staticRenderFns } from "./detail-asset-purchase.vue?vue&type=template&id=02b397c0&"
import script from "./detail-asset-purchase.vue?vue&type=script&lang=js&"
export * from "./detail-asset-purchase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports